import { render, staticRenderFns } from "./CetakSerahTerima.vue?vue&type=template&id=1872fe40&"
import script from "./CetakSerahTerima.vue?vue&type=script&lang=ts&"
export * from "./CetakSerahTerima.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1872fe40')) {
      api.createRecord('1872fe40', component.options)
    } else {
      api.reload('1872fe40', component.options)
    }
    module.hot.accept("./CetakSerahTerima.vue?vue&type=template&id=1872fe40&", function () {
      api.rerender('1872fe40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sales/berita-acara/ba-serah-terima/CetakSerahTerima.vue"
export default component.exports